<template>
<div>
    <div>
        <h3>Site Number Request</h3>
    </div>
    <div class="wrapper">
        <div class="row row-wider">
            <div class="col-md-12" style="min-height: 150px;">
                <loader v-if="siteNumberRequestLoading"/>
                <div>
                    <tabs nav-style="tabs" v-model="activeTabIndex">
                        <tab header="Request">
                            <projectHeader v-if="project.projectId" v-bind:project="project" />
                            <investigationHeader v-if="investigation.investigationId" v-bind:investigation="investigation"></investigationHeader>
                            <div v-if="siteNumberRequest.culturalResourceId && createdCrList.length > 0" style="margin-bottom: 20px;" class="alert alert-info" role="alert">
                                This Site Number Request has been approved.  Assigned Smithsonian Number(s): <strong>{{createdCrSmithNos}}</strong>
                            </div>
                            <div class="sectionHeaderRight" v-if="this.$route.params.siteNumberRequestId && (this.siteNumberRequest.projectId || this.siteNumberRequest.investigationId)">
                                <button name="newSnr" v-if="!isShpoReadOnly" class="btn btn-primary btn-block" @click="newRequest">New Site Number Request</button>
                                <!-- <router-link :to="{ path: '/SiteNumberRequest', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">New Site Number Request</router-link> -->
                            </div>
                            <div v-if="!siteNumberRequest.culturalResourceId && checkShpoRole">
                                <div style="margin-bottom: 20px;" class="alert alert-warning" role="alert">
                                    <span v-if="selectedCounties.length > 1">There are {{selectedCounties.length}} counties ({{selectedCounties.join(', ')}}) in this request, multiple smithsonian numbers will be assigned if approved.</span>
                                    <span v-if="selectedCounties.length === 1">County in this request: {{selectedCounties.join(', ')}}</span>
                                    <span v-if="selectedCounties.length === 0">There are no counties in this request.</span>
                                </div>
                            </div>
                            <fieldset :disabled="formDisabled">
                                <form class="form-horizontal" @submit.prevent="submitRequest" data-vv-scope="siteNumberRequest">
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">Request Type</label>
                                        <div class="col-md-4" v-bind:class="{ 'has-error': errors.has('Request Type', 'siteNumberRequest') }">
                                            <select class="form-control" name="Request Type" v-model="siteNumberRequest.siteNumberRequestTypeId" v-validate="'required'">
                                                <option disabled :value="null">Select a Request Type</option>
                                                <option v-for="requestType in requestTypeList" v-bind:value="requestType.requestTypeId" :key="requestType.requestTypeId">
                                                    {{requestType.description}}
                                                </option>
                                            </select>
                                            <span v-show="errors.has('Request Type', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('Request Type', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('Site Number / Site Identifier', 'siteNumberRequest') }">
                                        <label class="col-md-2 control-label">Site Name/Site Identifier</label>
                                        <div class="col-md-4">
                                            <input type="text" name="Site Number / Site Identifier" class="form-control" v-model="siteNumberRequest.siteName" placeholder="Site Number / Site Identifier"  v-validate="'required'">
                                            <span v-show="errors.has('Site Number / Site Identifier', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('Site Number / Site Identifier', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                        <label v-show="siteNumberRequest.siteNumberRequestTypeId === requestTypeEnum.Segment" class="col-md-2 control-label text-label">Head of Segment</label>
                                        <div v-show="siteNumberRequest.siteNumberRequestTypeId === requestTypeEnum.Segment" class="col-md-4 text-label">
                                            {{segmentHeadSiteNumber}}
                                            <a class="fa fa-edit" style="font-size: 16px;" v-on:click="showCRSelection()"></a>
                                        </div>
                                    </div>
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('Site Description', 'siteNumberRequest') }">
                                        <label class="col-md-2 control-label">Site Description</label>
                                        <div class="col-md-8">
                                            <textarea class="form-control" rows="3" name="Site Description" maxlength="300" v-model="siteNumberRequest.siteDescription" placeholder="Briefly describe the site"  v-validate="'required'">
                                            </textarea>
                                            <span v-show="errors.has('Site Description', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('Site Description', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group" >
                                        <label class="col-md-2 control-label">Collections</label>
                                        <div class="col-md-4">
                                            <div class="checkbox checkbox-inline">
                                                <input type="checkbox" id="collectionsCheckbox" autocomplete="off"  v-model="siteNumberRequest.collections" />
                                                    <label for="collectionsCheckbox">&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('Eligibility', 'siteNumberRequest') }">
                                        <label class="col-md-2 control-label">Eligibility</label>
                                        <div class="col-md-4">
                                            <select name="Eligibility" class="form-control" v-model="siteNumberRequest.eligibilityId" v-validate="'required'">
                                                <option disabled :value="null">Select a value</option>
                                                <option value="1">Eligible</option>
                                                <option value="2">Not Eligible</option>
                                                <option value="3">Unevaluated</option>
                                            </select>
                                            <span v-show="errors.has('Eligibility', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('Eligibility', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">Contributing Eligibility</label>
                                        <div class="col-md-4">
                                            <div class="checkbox checkbox-inline">
                                                <input type="checkbox" autocomplete="off" id="contributingCheckbox" v-model="siteNumberRequest.contributingEligibility" />
                                                    <label for="contributingCheckbox">&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('Primary Site Type', 'siteNumberRequest') }">
                                        <label class="col-md-2 control-label">Primary Site Type</label>
                                        <div class="col-md-4">
                                            <select v-if="siteNumberRequest.siteNumberRequestTypeId != requestTypeEnum.General" name="Primary Site Type"
                                                    class="form-control" v-model="siteNumberRequest.siteTypeId"  v-validate="'required'"
                                                    :disabled="siteNumberRequest.siteNumberRequestTypeId === requestTypeEnum.Segment">
                                                <option :value="null" disabled>Select a value</option>
                                                <option value="5">District</option>
                                            </select>
                                            <select v-else name="Primary Site Type" class="form-control" v-model="siteNumberRequest.siteTypeId" v-validate="'required'">
                                                <option :value="null" >Select a value</option>
                                                <option v-for="siteType in siteTypeList.filter(x=> { return x.isPrimary })" v-bind:value="siteType.id" :key="siteType.id">
                                                    {{siteType.description}}
                                                </option>
                                            </select>
                                            <span v-show="errors.has('Primary Site Type', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('Primary Site Type', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="siteNumberRequest.siteNumberRequestTypeId == requestTypeEnum.District"
                                        v-bind:class="{ 'has-error': errors.has('District Ownership', 'siteNumberRequest') }">
                                        <label  class="col-md-2 control-label text-label">District Ownership Type</label>
                                        <div class="col-md-4">
                                            <select class="form-control" name="District Ownership" v-model="siteNumberRequest.districtOwnershipTypeId" v-validate="'required'">
                                                <option :value="null" disabled>Select a value</option>
                                                <option v-for="type in districtOwnershipTypeList" v-bind:value="type.id" :key="type.id">
                                                    {{ type.description}}
                                                </option>
                                            </select>
                                            <span v-show="errors.has('District Ownership', 'siteNumberRequest')" class="has-error">
                                                {{errors.first('District Ownership', 'siteNumberRequest')}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">Secondary Site Type</label>
                                        <div class="col-md-6">
                                            <checkboxPanel :numColumns="4" :lookupList="siteTypeList" ref="siteTypePanel" :fieldName="'siteTypeId'" name="siteTypeCB" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">General Age</label>
                                        <div class="col-md-6">
                                            <div class="row well">
                                                <div v-for="timePeriod in timePeriodList" class="col-md-3" :key="timePeriod.index">
                                                    <div class="checkbox checkbox-inline">
                                                        <input type="checkbox" v-model="selectedTimePeriodList" v-bind:id="'timePeriod' + timePeriod.timePeriodId" v-bind:value="timePeriod.timePeriodId" />
                                                            <label v-bind:for="'timePeriod' + timePeriod.timePeriodId">{{ timePeriod.description}}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="checkShpoRole">
                                        <div class="form-group">
                                            <label class="col-md-2 control-label">Skip Shape File Upload / Manual Assign County</label>
                                            <div class="col-md-4">
                                                <div class="checkbox checkbox-inline">
                                                    <input type="checkbox" autocomplete="off" id="noShapeFileCb" v-model="siteNumberRequest.skipShapeFile" />
                                                    <label for="noShapeFileCb">&nbsp;</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group" v-show="siteNumberRequest.skipShapeFile">
                                            <label class="col-md-2 control-label">County Codes</label>
                                            <div class="col-md-8">
                                                <checkboxPanel :numColumns="4" :lookupList="countyCodeList" ref="countyCodePanel" :fieldName="'code'" name="countyCodeCB" />
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="siteNumberRequest.skipShapeFile">
                                            <label class="col-md-2 control-label">Site Location/Address</label>
                                            <div class="col-md-8">
                                                <textarea row="2" name="Site Location/Addres" class="form-control" v-model="siteNumberRequest.location" placeholder="Site Location/Address" />
                                            </div>
                                        </div>
                                    </template>
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">Features</label>
                                        <div class="col-md-8">
                                            <checkboxPanel v-show="filteredFeatureList.length > 0" :numColumns="4" :lookupList="filteredFeatureList" ref="featurePanel" :fieldName="'featureId'" name="featureCB" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-md-2 control-label">Artifacts</label>
                                        <div class="col-md-9">
                                            <div class="row well">
                                                <prehistoricArtifactSelection ref="prehistoricArtifactSelection" />
                                            </div>
                                            <br/>
                                            <div class="row well">
                                                <historicArtifactSelection ref="historicArtifactSelection" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-md-2">
                                        </div>
                                        <div v-if="!formDisabled" class="col-md-3">
                                            <button name="submitButton" class="btn btn-primary btn-block" type="submit" style="width:100px;">Save</button>
                                        </div>
                                    </div>
                                </form>
                            </fieldset>
                            <modal ref="segmentHeadSearch">
                                <h3 slot="header">Cultural Resource Search</h3>
                                <div slot="body">
                                    <culturalResourceSearch :addCulturalResource="setSegmentHead" :resultFilter="crSearchFilterSegment"/>
                                </div>
                            </modal>
                        </tab>
                        <tab header="Files" :disabled="siteNumberRequest.siteNumberRequestId == null">
                            <projectHeader v-bind:project="project" />
                            <div style="margin-top: 20px;">
                                <media :mediaTypeId="mediaTypeIdSiteNumberRequest" :parentId="siteNumberRequest.siteNumberRequestId" :formDisabled="formDisabled"
                                    :shapeFileAppend="shapeFileAppendEnabled" v-on:shapeFileAppendSave="saveShapeFileAppend" ref="media"></media>
                            </div>
                            <div style="margin-top: 20px;">
                                <hr />
                                <mediaLetter :mediaTypeId="mediaTypeIdSnrLetter" :parentId="siteNumberRequest.siteNumberRequestId" ref="mediaLetter"></mediaLetter>
                            </div>
                        </tab>
                        <tab header="Map" :disabled="siteNumberRequest.siteNumberRequestId == null">
                            <mapx :mediaTypeId="mediaTypeIdSiteNumberRequest" :parentId="siteNumberRequest.siteNumberRequestId"
                            :loadOnMount="false" ref="mapx"></mapx>
                        </tab>
                        <tab header="Workflow" :disabled="siteNumberRequest.siteNumberRequestId == null">
                            <projectHeader v-if="project.projectId" v-bind:project="project" />
                            <div style="margin-top: 20px;">
                                <workflow :workflowId="siteNumberRequestWorkflowId" :parentId="siteNumberRequest.siteNumberRequestId" ref="workflow"
                                v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
                            </div>
                            <div v-if="checkShpoRole" style="margin-top: 20px;">
                                <quickLetter :projectId="project ? project.projectId : null" :siteNumberRequestId="siteNumberRequest.siteNumberRequestId"
                                :mediaTypeId="mediaTypeIdSnrLetter" :parentId="siteNumberRequest.siteNumberRequestId"></quickLetter>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import siteNumberRequestService from '@/services/siteNumberRequestService'
import siteTypeService from '@/services/lookup/siteTypeService'
import artifactService from '@/services/lookup/artifactService'
import featureService from '@/services/lookup/featureService'
import projectService from '@/services/projectService'
import investigationService from '../services/investigationService'
import workflowService from '@/services/workflowService'
import mediaService from '@/services/mediaService'
import culturalResourceService from '@/services/culturalResourceService'
import roleService from '../services/roleService.js'
import userService from '@/services/userService.js'
import lookupService from '@/services/lookup/lookupService'
import { mapState } from 'vuex'

import { tab, tabs } from 'vue-strap'
import loader from '@/components/Loader.vue'
import projectHeader from '@/components/ProjectHeader.vue'
import investigationHeader from '../components/InvestigationHeader.vue'
import workflow from '@/components/Workflow.vue'
import checkboxPanel from '@/components/CheckBoxPanel.vue'
import modal from '@/components/Modal.vue'
import prehistoricArtifactSelection from '@/components/PrehistoricArtifactSelection.vue'
import historicArtifactSelection from '@/components/HistoricArtifactSelection.vue'
import media from '@/components/Media.vue'
import mediaLetter from '@/components/MediaLetter.vue'
import culturalResourceSearch from '@/components/CulturalResourceSearch'
import quickLetter from '../components/QuickLetter.vue'
import mapx from '@/views/MapNew'

export default {
    components: {
        loader,
        tabs,
        tab,
        projectHeader,
        investigationHeader,
        workflow,
        checkboxPanel,
        prehistoricArtifactSelection,
        historicArtifactSelection,
        media,
        modal,
        culturalResourceSearch,
        mediaLetter,
        quickLetter,
        mapx
    },
    data: function () {
        return {
            isMounted: false,
            siteNumberRequestLoading: true,
            isDebug: false,
            segmentHead: {},
            siteNumberRequestTypeId: '',
            siteNumberRequest: {
                siteTypeId: '',
                eligibilityId: '',
                artifactList: [],
                featureList: [],
                timePeriodList: [],
                secondarySiteTypeList: []
            },
            activeTabIndex: 0,
            requestTypeEnum: {
                General: 1,
                District: 2,
                Segment: 3
            },
            requestTypeList: [
                {requestTypeId: 1, description: 'General Site Number'},
                {requestTypeId: 2, description: 'New District / Linear Resource'},
                {requestTypeId: 3, description: 'Segment of Existing Linear Resource'}
            ],
            selectedArtifactList: [],
            filteredArtifactList: [],
            selectedFeatureList: [],
            selectedTimePeriodList: [],
            selectedSecondarySiteTypeList: [],
            featureList: [],
            filteredFeatureList: [],
            artifactCategoryList: [],
            artifactList: [],
            timePeriodList: [
                {timePeriodId: 1, description: 'Prehistoric'},
                {timePeriodId: 2, description: 'Protohistoric'},
                {timePeriodId: 3, description: 'Historic'},
                {timePeriodId: 4, description: 'Unknown'}
            ],
            siteTypeList: [],
            districtOwnershipTypeList: [],
            countyCodeList: [],
            project: {},
            investigation: {},
            createdCrList: [],
            createdCrSmithNos: '',
            // create Enum for each tab on the page, also keep track if the tab has been clicked and loaded
            tabsEnum: {
                request: 0,
                files: 1,
                filesLoaded: false,
                map: 2,
                mapLoaded: false,
                workflow: 3,
                workflowLoaded: false
            },
            currentWorkflowStatus: {}
        }
    },
    computed: {
        siteNumberRequestWorkflowId: function () {
            return workflowService.WorkflowEnum.SiteNumberRequest
        },
        mediaTypeIdSiteNumberRequest: function () {
            return mediaService.mediaType.SiteNumberRequest.toString()
        },
        mediaTypeIdSnrLetter: function () {
            return mediaService.mediaType.SiteNumberRequestLetter
        },
        segmentHeadSiteNumber: function () {
            if (this.segmentHead.culturalResourceId) {
                return (this.segmentHead.siteName ? (this.segmentHead.smithsonianNumber + ' - ' + this.segmentHead.siteName) : this.segmentHead.smithsonianNumber)
            } else {
                return 'Not Set'
            }
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        checkShpoRole: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isShpoReadOnly: function () {
            return this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        shapeFileAppendEnabled: function () {
            return this.checkShpoRole && this.currentWorkflowStatus.workflowStatusId === workflowService.SnrWfStatusEnum.PendingApproval
        },
        formDisabled: function () {
            return (this.isSubmitted) || this.isShpoReadOnly
        },
        selectedCounties: function () {
            if (this.isMounted && this.checkShpoRole) {
                return this.$refs.countyCodePanel.selectedList
            } else {
                return []
            }
        },
        isSubmitted: function () {
            return this.currentWorkflowStatus.workflowStatusId && this.currentWorkflowStatus.workflowStatusId > workflowService.SnrWfStatusEnum.PendingDataEntry
        }
    },
    watch: {
        'siteNumberRequest.siteNumberRequestTypeId': function (val) {
            this.siteNumberRequest.siteNumberRequestTypeId = val
            if (val !== this.requestTypeEnum.General) {
                this.siteNumberRequest.siteTypeId = 5 //District
            } else if (this.siteNumberRequest.siteTypeId === 5) {
                this.siteNumberRequest.siteTypeId = null
            }
        },
        selectedTimePeriodList: function (timePeriods) {
            loggingService.log(this.isDebug, 'Site Number Request', 'Selected TimePeriod watch ' + timePeriods + 'typeof : ' + typeof someValue)
            var newFilteredList = []
            this.artifactList.forEach(artifact => {
                if (timePeriods.indexOf(artifact.timePeriodId) >= 0) {
                    newFilteredList.push(artifact)
                }
            })
            this.filteredArtifactList = newFilteredList
            this.filteredFeatureList = this.featureList.filter(feature => {
                return timePeriods.includes(feature.timePeriodId)
            })
            loggingService.log(this.isDebug, 'Site Number Request', 'Filtered artifact list ' + this.filteredArtifactList.length)
        },
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'Site Number Request', 'Changing to tab ' + val)
            switch (val) {
            case this.tabsEnum.files:
                loggingService.log(this.isDebug, 'Site Number Request', 'Showing media, emitting event')
                this.$refs.media.loadMedia()
                break
            case this.tabsEnum.map:
                if (!this.tabsEnum.mapLoaded) this.$refs.mapx.createMap()
                this.tabsEnum.mapLoaded = true
                break
            case this.tabsEnum.workflow:
                loggingService.log(this.isDebug, 'Site Number Request', 'Showing workflow, emitting event')
                this.$refs.workflow.loadData()
                break
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'SiteNumberRequest', 'mounted')
        loggingService.logRaw(this.$refs)
        this.isMounted = true
        Promise.all([this.loadLookups(), this.loadData()]).then(response => {
            loggingService.log(this.isDebug, 'SiteNumberRequest', 'Loading project & investigation')
            Promise.all([this.loadProject(), this.loadInvestigation()]).then(response2 => {
                loggingService.log(this.isDebug, 'SiteNumberRequest', 'Done with all loading.')
                this.siteNumberRequestLoading = false
            })
        })
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Number Request', message)
        },
        loadProject () {
            loggingService.log(this.isDebug, 'Site Number Request', 'LoadProject started')
            var projectId = this.$route.query.projectId
            if (!projectId) {
                loggingService.log(this.isDebug, 'Site Number Request', `loadProject; projectId from siteNumberRequest.projectId : ${this.siteNumberRequest.projectId}`)
                projectId = this.siteNumberRequest.projectId
            }
            if (!projectId) {
                loggingService.log(this.isDebug, 'Site Number Request', 'Site number does not exist, and no project number. So no banner')
                return Promise.resolve(true)
            }
            return projectService.search(this.$http, { projectId: projectId }).then(response => {
                this.project = response.data.length > 0 ? response.data[0] : {}
                return response
            })
        },
        loadInvestigation () {
            var investigationId = this.$route.query.investigationId
            if (!investigationId) investigationId = this.siteNumberRequest.investigationId
            if (!investigationId) return Promise.resolve(true)
            return investigationService.get(this.$http, investigationId).then(response => {
                this.investigation = response.data
                return response
            })
        },
        loadSiteNumberRequest () {
            var refKeys = Object.keys(this.$refs)
            this.log('Key Length: ' + refKeys.length)
            return siteNumberRequestService.get(this.$http, this.$route.params.siteNumberRequestId).then(response => {
                this.siteNumberRequest = response.data
                this.$refs.prehistoricArtifactSelection.selectedList = this.siteNumberRequest.artifactList.map(x => { return x.artifactId })
                this.$refs.historicArtifactSelection.selectedList = this.siteNumberRequest.artifactList.map(x => { return x.artifactId })
                this.selectedTimePeriodList = this.siteNumberRequest.timePeriodList.map(x => { return x.timePeriodId })
                this.$refs.featurePanel.selectedList = this.siteNumberRequest.featureList.map(x => { return x.featureId })
                this.$refs.siteTypePanel.selectedList = this.siteNumberRequest.siteTypeList.map(x => { return x.siteTypeId })
                //shapeFileAppendMediaId
                if (this.$refs.media) {
                    this.$refs.media.shapeFileAppendMediaId = this.siteNumberRequest.shapeFileAppendMediaId
                }
                //load current workflow status
                this.loadWorkflowStatus(this.siteNumberRequest.siteNumberRequestId)
                //load countyCodeList
                if (this.checkShpoRole && this.siteNumberRequest.countyCodeList) {
                    this.$refs.countyCodePanel.selectedList = this.siteNumberRequest.countyCodeList.split(', ')
                }
                //get the culturalResource list if one is assigned
                if (this.siteNumberRequest.culturalResourceId) {
                    culturalResourceService.searchBySiteNumberRequestId(this.$http, this.siteNumberRequest.siteNumberRequestId).then(result => {
                        this.createdCrList = result.data
                        var smithNoStrings = this.createdCrList.map(cr => {
                            return cr.smithsonianNumber
                        })
                        this.createdCrSmithNos = smithNoStrings.join(', ')
                    })
                }
                if (this.siteNumberRequest.headCulturalResourceId) {
                    this.log('found segment head id')
                    var headSearchDto = {
                        culturalResourceId: this.siteNumberRequest.headCulturalResourceId,
                        showInactive: true
                    }
                    culturalResourceService.search(this.$http, headSearchDto).then(response2 => {
                        this.log('found segment head dto: ' + response2.data.smithsonianNumber)
                        this.segmentHead = response2.data[0]
                        return response2
                    })
                } else {
                    return response
                }
            })
        },
        loadWorkflowStatus (snrId) {
            this.log('loadWorkflowStatus for siteNumberRequestId: ' + snrId)
            return workflowService.currentWorkflowStatusDto(this.$http, this.siteNumberRequestWorkflowId, snrId).then(response => {
                this.currentWorkflowStatus = response.data
                return response
            })
        },
        loadSiteType () {
            return siteTypeService.listLookup(this.$http).then(response => {
                this.siteTypeList = response.data.filter(x => {
                    return x.description !== 'District'
                }).map(x => {
                    x.siteTypeId = x.id
                    x.isPrimary = !(x.description === 'Linear' || x.description === 'Landscape' || x.description === 'Lithic Landscape')
                    return x
                })
                return response
            })
        },
        loadFeature () {
            return featureService.listFeature(this.$http).then(response => {
                this.featureList = response.data
                return response
            })
        },
        loadArtifact () {
            return artifactService.listArtifact(this.$http).then(result => {
                this.artifactList = result.data
                return result
            })
        },
        loadArtifactCategory () {
            return artifactService.listArtifactCategory(this.$http).then(result => {
                this.artifactCategoryList = result.data
                this.artifactCategoryList.forEach(category => {
                    category.artifactList = []
                    category.open = false
                })
                return result
            })
        },
        loadDistrictOwnershipTypes () {
            return lookupService.listLookup(this.$http, 'DistrictOwnershipType').then(response => {
                this.districtOwnershipTypeList = response.data
                return response
            })
        },
        loadCountyCodes () {
            return lookupService.listLookup(this.$http, 'County').then(response => {
                this.countyCodeList = response.data
                return response
            })
        },
        loadLookups () {
            loggingService.log(this.isDebug, 'Site Number Request', 'Creating lookup promises')
            Promise.all([
                this.loadSiteType(),
                this.loadArtifact(),
                this.loadArtifactCategory(),
                this.loadFeature(),
                this.loadDistrictOwnershipTypes(),
                this.loadCountyCodes()
            ]).then(response => {
                loggingService.log(this.isDebug, 'Site Number Request', 'Done loading lookups')
                return response
            })
        },
        loadData () {
            loggingService.log(this.isDebug, 'Site Number Request', 'Loading Data')
            if (this.$route.params.siteNumberRequestId) {
                loggingService.log(this.isDebug, 'Site Number Request', 'Loading by site number request: ' + this.$route.params.siteNumberRequestId)
                return this.loadSiteNumberRequest()
            } else {
                loggingService.log(this.isDebug, 'Site Number Request', 'Creating site number request')
                return Promise.resolve(this.createNewSiteNumberRequest())
            }
        },
        createNewSiteNumberRequest () {
            this.siteNumberRequest = {
                siteNumberRequestTypeId: null,
                siteTypeId: null,
                eligibilityId: null,
                artifactList: [],
                featureList: [],
                timePeriodList: [],
                secondarySiteTypeList: [],
                projectId: this.$route.query.projectId || null,
                investigationId: this.$route.query.investigationId || null
            }
        },
        submitRequest () {
            this.$validator.validateAll('siteNumberRequest').then(result => {
                loggingService.log(this.isDebug, 'siteNumberRequest', 'done validating')
                if (result) {
                    loggingService.log(this.isDebug, 'Site Number Request', ' number of artfacts ' + this.selectedArtifactList.length)

                    this.siteNumberRequest.artifactList = this.$refs['prehistoricArtifactSelection'].filteredSelectedList.concat(this.$refs['historicArtifactSelection'].filteredSelectedList)
                    this.siteNumberRequest.featureList = this.$refs['featurePanel'].selectedList
                    this.siteNumberRequest.timePeriodList = this.selectedTimePeriodList
                    this.siteNumberRequest.secondarySiteTypeList = this.$refs['siteTypePanel'].selectedList
                    this.siteNumberRequest.headCulturalResourceId = this.segmentHead.culturalResourceId
                    if (this.checkShpoRole) {
                        this.siteNumberRequest.countyCodeUploadList = this.$refs.countyCodePanel.selectedList
                    }
                    siteNumberRequestService.put(this.$http, this.siteNumberRequest).then(response => {
                        var result = response.data
                        if (result.isValid) {
                            this.$router.push('/SiteNumberRequest/' + result.id)
                            this.loadData()
                            // //find the site number request object from the result array
                            // var snr = result.objectList.find(x => { return x.siteNumberRequestId === result.id })
                            // this.siteNumberRequest = snr
                        }
                    })
                }
            })
        },
        showCRSelection () {
            this.$refs.segmentHeadSearch.open()
        },
        setSegmentHead (culturalResource) {
            this.log('set segment head, ' + culturalResource.smithsonianNumber)
            this.segmentHead = culturalResource
            this.$refs.segmentHeadSearch.close()
        },
        workflowOnSubmitSuccess (validationResult) {
            //reload data
            this.loadData()
            //trigger media letter refresh if letter gen is triggered
            if (validationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
        },
        saveShapeFileAppend (value) {
            this.siteNumberRequest.shapeFileAppendMediaId = value
            this.submitRequest()
        },
        newRequest () {
            if (!(this.siteNumberRequest.projectId || this.siteNumberRequest.investigationId)) return
            this.siteNumberRequestLoading = true
            this.$router.push(`/SiteNumberRequest?projectId=${this.siteNumberRequest.projectId}&investigationId=${this.siteNumberRequest.investigationId}`)
            this.$router.go()
        },
        crSearchFilterSegment (searchResult) {
            this.log(`Filtering Segments: ${searchResult.length}`)
            var filteredResults = searchResult.filter(cr => {
                return cr.segment < 1
            })
            this.log('Result size after filter: ' + filteredResults.length)
            return filteredResults
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteNumberRequest.vue?24f42d1b